<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <path
            class="a"
            d="M9,12.75H2.25a1.5,1.5,0,0,1-1.5-1.5v-9A1.5,1.5,0,0,1,2.25.75h18a1.5,1.5,0,0,1,1.5,1.5v6"
        />

        <path
            class="a"
            d="M5.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375"
        />

        <path
            class="a"
            d="M11.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375"
        />

        <path
            class="a"
            d="M17.25,6.375a.375.375,0,1,1-.375.375.374.374,0,0,1,.375-.375"
        />

        <polyline class="a" points="19.5 15.75 23.25 15.75 23.25 11.25" />

        <path class="a" d="M23.061,15.75a6,6,0,1,0-1.121,5.243" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'PasswordResetIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
